import {
  ButtonDisplayMode,
  ButtonHierarchy,
  ButtonShape,
  ButtonSize,
  MainButton,
  Typography,
  TypographySize,
  TypographyWeight,
} from "@beydesign/storybook"
import { Box, SxProps, Theme, useMediaQuery, useTheme } from "@mui/material"
import React from "react"
import { Agent } from "../../types/Agent"

interface ChatWithAgentProps {
  agent: Agent
  sx?: SxProps<Theme>
  onBackButtonClick?: () => void
}

export const ChatWithAgent: React.FC<ChatWithAgentProps> = ({
  agent,
  sx,
  onBackButtonClick,
}) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"))

  const top = `var(--spacing-tokens-size-in-px-spacing-spacing-${isMobile ? "6xl" : "5xl"})`
  const left = `var(--spacing-tokens-size-in-px-spacing-spacing-${isMobile ? "xl" : "5xl"})`

  return (
    <Box
      position="absolute"
      top={top}
      left={left}
      sx={{ zIndex: 1, ...sx }}
      display={"flex"}
      flexDirection={"row"}
      alignItems={"center"}
      gap={"12px"}
    >
      {onBackButtonClick && (
        <MainButton
          hierarchy={ButtonHierarchy.SecondaryTransparent}
          size={ButtonSize.md}
          displayIconMode={ButtonDisplayMode.Only}
          displayIcon="ArrowLeft"
          shape={ButtonShape.Circle}
          style={{ border: "none" }}
          onClick={onBackButtonClick}
        />
      )}
      {!onBackButtonClick && (
        <MainButton
          hierarchy={ButtonHierarchy.SecondaryTransparent}
          size={ButtonSize.md}
          displayIconMode={ButtonDisplayMode.Only}
          displayIcon="UserCircleGear"
          shape={ButtonShape.Circle}
          style={{ border: "none" }}
          onClick={null}
        />
      )}
      <Typography
        weight={TypographyWeight.SemiBold}
        size={TypographySize.HeadingXS}
        color="var(--colors-light-text-text-white)"
      >
        Chat with {agent?.name || "Agent"}
      </Typography>
    </Box>
  )
}
